import { ApplicationConfig, importProvidersFrom } from '@angular/core';
import { provideAnimations } from '@angular/platform-browser/animations';
import { HTTP_INTERCEPTORS, HttpClient, provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { AuthHeaderInterceptor } from './authentication/auth-header.interceptor';
import {
  provideRouter,
  withEnabledBlockingInitialNavigation,
  withHashLocation,
  withInMemoryScrolling,
  withRouterConfig
} from '@angular/router';

import { SidebarModule } from '@coreui/angular-pro';
import { IconSetService } from '@coreui/icons-angular';
import { routes } from './app.routes';

//Store Effects 
import { mainEffects } from './store/main/effects'
import { paymentEffects } from './store/payment/effects'
import { uiEffects } from './store/ui/effects'
import { scheduleEffects } from './store/schedule/effects'
import { spotsEffects } from './store/spots/effects'

//Store Redusers
import { reducers } from './store/app.reducers'
import { MetaReducer, provideState, provideStore } from '@ngrx/store';
import { provideEffects } from '@ngrx/effects'
import { AuthGuard } from './authentication/auth.guard';
import { provideEnvironmentNgxMask } from 'ngx-mask'
import { provideCharts, withDefaultRegisterables } from 'ng2-charts';
import * as UiActions from './store/ui/actions/ui.actions';
import { AppState } from './store/app.state';


export function clearStateMetaReducer(reducer: any) {
  return function (state: any, action: any) {
    if (action.type === UiActions.clearState.type) {
      state = undefined;
    }
    return reducer(state, action);
  };
}

const metaReducers: MetaReducer<AppState>[] = [clearStateMetaReducer];

export const appConfig: ApplicationConfig = {
  providers: [
    provideRouter(routes,
      withRouterConfig({
        onSameUrlNavigation: 'reload'
      }),
      withInMemoryScrolling({
        scrollPositionRestoration: 'top',
        anchorScrolling: 'enabled'
      }),
      withEnabledBlockingInitialNavigation(),
      withHashLocation()
    ),
    importProvidersFrom(SidebarModule),
    IconSetService,
    AuthGuard,
    provideAnimations(),
    provideStore(reducers, { metaReducers }),
    provideEffects([...mainEffects, ...paymentEffects, ...scheduleEffects, ...uiEffects, ...spotsEffects]),
    provideHttpClient(
      withInterceptorsFromDi()
    ),
    {
      provide: HTTP_INTERCEPTORS,
      useClass: AuthHeaderInterceptor,
      multi: true
    },
    provideEnvironmentNgxMask(),
    provideCharts(withDefaultRegisterables())

  ]
};



